<template>
    <div class="wrapper">
        <span style="display: inline-block; min-width: 125px">{{ phoneNumber }}</span><span v-html="flag"></span>
    </div>
</template>

<script>
  export default {
    props: [
      'row'
    ],

    computed: {
      /**
       * @return {string}
       */
      phoneNumber() {
        return this.row.model.phone_number;
      },

      /**
       * @return {string}
       */
      flag() {
        return this.row.flag;
      },
    },
  }
</script>
